import React from 'react'

import { css } from 'src/ui/style/css'
import { useTran } from 'src/i18n/useTran'
import { msg } from 'src/i18n/texts/keys'
import { useTheme } from 'src/ui/style/useTheme'
import { fmtCountdown } from 'src/ui/chatbot/components/InactivityTimers'

const DeskIdleWarningNotice: React.FC<{
    etaMs: number
    onClose: () => void
}> = ({ etaMs, onClose }) => {
    const t = useTran()
    const th = useTheme()
    return (
        <div
            role="alert"
            aria-live="polite"
            css={css`
                position: sticky;
                top: 8px;
                margin: 8px;
                border-radius: 12px;
                border: 1px solid rgba(17, 24, 39, 0.08);
                background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
                box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
                padding: 12px 14px;
                animation: deskBannerIn 180ms ease-out;
                @keyframes deskBannerIn {
                    from {
                        transform: translateY(-4px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
            `}
        >
            <div
                css={css`
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                `}
            >
                <span
                    aria-hidden="true"
                    css={css`
                        width: 10px;
                        height: 10px;
                        border-radius: 999px;
                        background: ${th.colors.secondary};
                        box-shadow: 0 0 0 3px rgba(243, 208, 62, 0.18);
                        margin-top: 6px;
                    `}
                />
                <div
                    css={css`
                        flex: 1;
                    `}
                >
                    <div
                        css={css`
                            font-weight: 700;
                            color: #111827;
                        `}
                    >
                        {t(msg.chatbot.chat.idleWarningTitle)}
                    </div>
                    <div
                        css={css`
                            margin-top: 2px;
                            font-size: 14px;
                            line-height: 1.45;
                            color: #374151;
                        `}
                    >
                        {t(msg.chatbot.chat.idleWarningBody)}{' '}
                        <span
                            css={css`
                                display: inline-block;
                                padding: 2px 8px;
                                border-radius: 999px;
                                font-variant-numeric: tabular-nums;
                                font-family: ui-monospace, SFMono-Regular, Menlo,
                                    monospace;
                                background: rgba(243, 208, 62, 0.16);
                                color: #92400e;
                            `}
                            aria-live="polite"
                        >
                            {fmtCountdown(etaMs)}
                        </span>
                        . {t(msg.chatbot.chat.idleWarningAction)}
                    </div>
                </div>

                <button
                    onClick={onClose}
                    aria-label="×"
                    css={css`
                        appearance: none;
                        border: 0;
                        background: transparent;
                        cursor: pointer;
                        padding: 4px;
                        border-radius: 8px;
                        color: #6b7280;
                        transition: background 120ms ease;
                        &:hover {
                            background: rgba(17, 24, 39, 0.06);
                        }
                        &:active {
                            transform: translateY(1px);
                        }
                    `}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default DeskIdleWarningNotice
